import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'


if (!window.sandsVueAppInitialized) {

  document.addEventListener("DOMContentLoaded", function () {

    const vueEls = document.getElementsByClassName('vueApp2');
    if (vueEls && vueEls.length > 0) {
      for (const vueEl of vueEls) {
        createApp(App, { ...vueEl.dataset }).use(i18n).mount('#' + vueEl.id)
      }
    }
  });

  window.sandsVueAppInitialized = true;
}

